import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withStyles } from '@mui/styles';
import nextEvent from '../../utils/next-event';
import styles from '../../../styles/views/card';
import CardBase from '../../../../view-widgets/card/base';

function CardView({
  applet,
  classes,
  ...otherProps
}) {
  const {
    name, description, image, actions, logo, customProperties,
  } = applet;
  const next = moment.unix(nextEvent(applet))
    .calendar(null, { sameElse: 'dddd, MMMM Do YYYY, h:mm a' });

  return (
    <CardBase
      image={image}
      logo={logo}
      title={name}
      subheader={next}
      description={description}
      actions={actions}
      classes={classes}
      customProperties={customProperties}
      {...otherProps}
    />
  );
}

CardView.propTypes = {
  applet: PropTypes.shape({
    name: PropTypes.string.isRequired,
    startDate: PropTypes.number.isRequired,
    description: PropTypes.string,
    logo: PropTypes.shape({
      contentURL: PropTypes.string,
    }),
    image: PropTypes.shape({
      contentURL: PropTypes.string,
    }),
    customProperties: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.node,
      unit: PropTypes.node,
      label: PropTypes.node,
    })),
    actions: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      target: PropTypes.string,
    })),
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export default withStyles(styles)(CardView);
